import "../Main.css";
import { GoArrowRight } from "react-icons/go";
import { Link } from "react-router-dom";


function Main() {
  return ( <>
    <div className='container-1'>
      <div className="content-container">
        <div id="contentnav">
          <div id="l-content">
            <h3>ZustGo <br/>Redefining Delivery!</h3><br/>
            <h6 id="subhead">Order anything from your preferred <br/>Local Restaurants / Vendors without ever leaving the <br/>comfort of your home!</h6>
            <div id="l-content-button">
              <Link to="/contactus" onClick={() => window.scrollTo(0,0)} style={{ textDecoration: 'none' }}>
                <button id="lcb-input1">Get in Touch</button>
              </Link>
              <button 
                id="lcb-input2" 
                onClick={() => document.getElementById('container-6')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Partner With Us
              </button>
            </div>
            <h5>Available in both Android</h5>
            <a href="https://play.google.com/store/apps/details?id=com.zustgo.customer" target="_blank" rel="noopener noreferrer">
            <img id="playstoreimg"  src="/Image/playstore.png" alt="Play Store" style={{width: "205px", marginLeft: "-26px"}} />
            </a>
          </div>

          <div id="r-content">
            <img src="/Image/contentimg1.png" alt="logo" className="r-logo1" />
            <img src="/Image/contentimg2.png" alt="logo" className="r-logo2" />
          </div>
        </div>
      </div>
    </div>

    <div id="container-2">
      <div className="content-container features-flex">
        <div id="deliverydes">
          <img src="/Image/delivery.png" alt="logo" style={{width:"150px"}} className="delivery" />
          <div className="text">
            <h3>Fastest Delivery</h3>
            <h4>Get your food in less than 1 hour</h4>
          </div>
        </div>

        <div id="mobileappdes">
          <img src="/Image/mobile.png" alt="logo" style={{width:"150px"}} className="mobileapp" />
          <div className="text">
            <h3>Mobile App</h3>
            <h4>Easy to use Mobile App</h4>
          </div>
        </div>

        <div id="supportdes">
          <img src="/Image/customer.png" alt="logo" style={{width:"150px"}} className="support" />
          <div className="text">
            <h3>24/7 Support</h3>
            <h4>24/7 Customer Service</h4>
          </div>
        </div>
      </div>
    </div>

    <div id="container-3">
      <div id="headertext">
        <h3>HOW IT WORKS</h3>
        <h1>Easy Step From Your Phone</h1>
        <h5>Download the app and place your order in few second, its that simple..!</h5>
      </div>

      <div id="con-3-content">

        <div id="con-3-l-content">
          <img src="/Image/Group.png" alt="logo" style={{ width: "100%", maxWidth: "100%", height: "auto", display: "block" }} />
        </div>


        <div id="con-3-r-content">
        <div id="Restraurants">
          <img src="/Image/text3.1.png" alt="logo" className="text3-1" />
          <div id="text-3">
            <h2>01. Find Restaurants / Shops</h2>
            <h4>Choose your delivery location and pick your favourite shop</h4>
          </div>
        </div>

        <div id="Menu">
          <img src="/Image/text3.2.png" alt="logo" className="text3-2" />
          <div id="text-3">
            <h2>02. Choose your favorite Menu</h2>
            <h4>Add your items to the cart and place order</h4>
          </div>
        </div>

        <div id="DeliveryExecutive">
          <img src="/Image/text3.3.png" alt="logo" className="text3-3" />
          <div id="text-3">
            <h2>03. Delivery Executive Picks your order</h2>
            <h4>Once the order is prepared by the shop, our delivery executive picks it from the shop</h4>
          </div>
        </div>

        <div id="Delivery">
          <img src="/Image/text3.4.png" alt="logo" className="text3-4" />
          <div id="text-3">
            <h2>04. Your Order Gets Delivered</h2>
            <h4>Our Delivery Executive delivers the order at your doorstep.</h4>
          </div>
        </div>
      </div>
      </div>
      
    </div>


    <div id="container-4">
      <div id="con-4-header">
        <div id="con-4-header-row">
          <div>
            <h2>Popular Menu</h2>
            <h3>You name it, We have it....All in One App</h3>
          </div>
          <Link to="/popularmenu" className="view-all-btn desktop-view-btn">View All</Link>
        </div>
      </div>

      <div id="con-4-content">
        <div className="con-4-card">
          <img src="/Image/Menu1.jpg" alt="logo" className="Menu1" />
        </div>
        <div className="con-4-card">
          <img src="/Image/Menu2.jpg" alt="logo" className="Menu2" />
        </div>
        <div className="con-4-card">
          <img src="/Image/Menu3.jpg" alt="logo" className="Menu3" />
        </div>
        <div className="con-4-card">
          <img src="/Image/Menu4.jpg" alt="logo" className="Menu4" />
        </div>
      </div>

      <div id="con-4-footer">
        <Link to="/popularmenu" className="mobile-view-btn">
          View All
        </Link>
      </div>
      

    </div>

    <div id="container-5">
      <div className="content-container">
        <div className="iso-showcase-container">
          <div className="iso-phone">
            <img src="/Image/app_screen6.jpg" alt="Restaurant Menu Screen" />
          </div>
          <div className="iso-phone">
            <img src="/Image/app_screen4.jpg" alt="Nearby Stores Screen" />
          </div>
          <div className="iso-phone">
            <img src="/Image/app_screen2.jpg" alt="Payment Method Screen" />
          </div>
          <div className="iso-phone">
            <img src="/Image/app_screen5.jpg" alt="Checkout Screen" />
          </div>
          <div className="iso-phone">
            <img src="/Image/app_screen1.jpg" alt="Foods List Screen" />
          </div>
          <div className="iso-phone">
            <img src="/Image/app_screen4.jpg" alt="Nearby Stores Screen Duplicate" />
          </div>
        </div>
      </div>
    </div>

    <div id="container-6">
      <div className="content-container">
        <div id="heading">
          <h3 style={{ fontSize: "24px", fontWeight: "500" }}>JOIN US</h3>
          <h1 style={{ fontSize: "38px", fontWeight: "900" }}>Want to join us?</h1>
          <h5 style={{ fontSize: "14px", fontWeight: "400" }}>Partner and growth us</h5>
        </div>
        <div id="content">
          <div className='row'>

            <div className='col'>
              <div className='card'>
                <img className='img-fluid' id="earnimg" src="/Image/earnmoney.png" alt="img"/>
                <div className='card-body'>
                  <div className='card-text-group'>
                    <h3>Become a Partner</h3>
                    <h6>Attract more customers, List your shop with us</h6>
                  </div>
                  <Link id="elink" to="/partner" onClick={() => window.scrollTo(0,0)}>Earn Money <GoArrowRight /></Link>
                </div>
              </div>
            </div>

            <div className='col'>
              <div className='card'>
                <img className='img-fluid' id="getstarted" src="/Image/getstarted.png" alt="img"/>
                <div className='card-body'>
                  <div className='card-text-group'>
                    <h3>Become a Driver</h3>
                    <h6>Join us as a delivery Executive</h6>
                  </div>
                  <Link id="elink" to="/driver" onClick={() => window.scrollTo(0,0)}>Get Started <GoArrowRight /></Link>
                </div>
              </div>
            </div>

            <div className='col'>
              <div className='card'>
                <img className='img-fluid' id="signup" src="/Image/signup.png" alt="img"/>
                <div className='card-body'>
                  <div className='card-text-group'>
                    <h3>Become a Franchisee</h3>
                    <h6>Start and operate ZustGo in your locality</h6>
                  </div>
                  <Link id="elink" to="/franchisee" onClick={() => window.scrollTo(0,0)}>Sign up <GoArrowRight /></Link>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div id="container-7">
      <div className="content-container download-inner">
        <div id="container">
          <h2 style={{ fontSize: "42px", fontWeight: "550", marginTop: "30px" }}>Download <br/>ZustGo</h2><br/><br/>
          <h5 style={{ fontSize: "15px", fontWeight: "400" }} id="subhead">Order anything from your preferred <br/>Local Restaurants / Vendors without ever leaving the <br/>comfort of your home!</h5><br/>
          <h4 style={{ fontSize: "16px", fontWeight: "550" }}>Available in Android</h4>
          <a href="https://play.google.com/store/apps/details?id=com.zustgo.customer" target="_blank" rel="noopener noreferrer">
            <img id="playstoreimg" src="/Image/playstore.png" alt="Play Store" style={{width: "200px", height: "100px", marginLeft: "-24px"}} />
          </a>
        </div>
        <div id="container-7-r">
          <img src="/Image/Cont-7.png" alt="Play Store" />
        </div>
      </div>
    </div>


    <div id="container-8">
      <div id="heading-8">
        <h3>F A Q</h3>
        <h2>Frequently Asked Questions</h2>
        <h6>Get your doubts clarified..!</h6>
      </div>
      
      <div className="container">
    <div className="row g-4">

      <div className="col-md-6">

        <div className="accordion" id="faqLeft">

          <div className="accordion-item faq-card">
            <h2 className="accordion-header">

              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq1"
                style={{
                  width: "100%",
                  minHeight: "63px",
                }}
              >
                How long will it take to deliver my order?
              </button>

            </h2>

            <div
              id="faq1"
              className="accordion-collapse collapse"
              data-bs-parent="#faqLeft"
            >
              <div className="accordion-body">
                Delivery time depends on the merchant,
                distance and weather conditions.
                On average, our delivery time is
                within 45 min
              </div>
            </div>
          </div>

          <div className="accordion-item faq-card mt-4">
            <h2 className="accordion-header">

              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq2"
                style={{
                  width: "100%",
                  minHeight: "63px",
                }}
              >
                What kind of payment options available?
              </button>

            </h2>

            <div
              id="faq2"
              className="accordion-collapse collapse"
              data-bs-parent="#faqLeft"
            >
              <div className="accordion-body">
                We have multiple payment options Cash on Delivery, Online payment
                (Netbanking,UPI,Cards etc),
              </div>
            </div>
          </div>

        </div>
      </div>

      
      <div className="col-md-6">

        <div className="accordion" id="faqRight">

          
          <div className="accordion-item faq-card">
            <h2 className="accordion-header">

              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq3"
                style={{
                  width: "100%",
                  minHeight: "63px",
                }}
              >
                Can I cancel my order?
              </button>

            </h2>

            <div
              id="faq3"
              className="accordion-collapse collapse"
              data-bs-parent="#faqRight"
            >
              <div className="accordion-body">
                You may be able to cancel order before the order is confirmed by the merchant,
                once the order is confirmed you will not be able to cancel the order.
              </div>
            </div>
          </div>

          <div className="accordion-item faq-card mt-4">
            <h2 className="accordion-header">

              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq4"
                style={{
                  width: "100%",
                  minHeight: "63px",
                }}
              >
                My order was cancelled, will i get a refund?
              </button>

            </h2>

            <div
              id="faq4"
              className="accordion-collapse collapse"
              data-bs-parent="#faqRight"
            >
              <div className="accordion-body">
                Yes, for cancelled orders you will get a full refund. However the refund process 
                will take 3-5 working days. 
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>    

  </div>
      

        
      </div>
    </>
  );
}

export default Main;